import withNumberFormat from "../hoc/withNumberFormat";

export default withNumberFormat({ format: "(###) ###-####", mask: "_" });
